import React from 'react'
import retroPC from "../assets/images/image-retro-pcs.jpg"
import topLaptops from "../assets/images/image-top-laptops.jpg"
import gamingGrowth from "../assets/images/image-gaming-growth.jpg"

function Article(props) {
    return (
        <section className="bottom-article">
            <img
                src={props.image}
                alt={props.alt}
                width='100'
                height='127'
                loading='lazy'
            />
            <div className="bottom-article-content">
                <h3 className='article-number'>0{props.number}</h3>
                <a href="/" className="bottom-news-title">
                    {props.title}
                </a>
                <a href="/" className="bottom-news-content">
                    {props.content}
                </a>
            </div>
        </section>
    )
}

const BottomNews = () => {
    return (
        <section className="bottom-news">
            <Article
                image={retroPC}
                alt='Retro PCs'
                number={1}
                title="Reviving retro PCs"
                content="What happens when old PCs are given modern upgrades"
            />
            <Article
                image={topLaptops}
                alt='Top 10 Laptops'
                number={2}
                title="Top 10 Laptops of 2022"
                content="Our best picks for various needs and budgets"
            />
            <Article
                image={gamingGrowth}
                alt='The growth of gaming'
                number={3}
                title="The Growth of Gaming"
                content="How the pandemic has sparked fresh opportunities"
            />
        </section>
    )
}

export default BottomNews;